import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, FormHelperText, styled, TextField, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useContext, useEffect, useState } from "react";
import { OverallDataContext } from "../../pages/CalculatorPage";

export default function GroupedFields({ options, groupedOptions, units, category, checkInputValue, errorMsg, setFocus, isReadOnly }) {
    const placeholderData = useContext(OverallDataContext).placeholderData;

    const [expanded, setExpanded] = useState('');
    const handleExpand = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const [values, setValues] = useState(
        Object.fromEntries((options).map((f) => [f?.id_name, 0]))
    );

    // Ensure total is 100% and restrict values to 2 decimal places
    const handleChange = (id_name, newValue) => {
        setValues(prev => ({ ...prev, [id_name]: newValue }));
        checkInputValue(id_name, newValue);
    };

    useEffect(()=>{
        // Populate placeholder values based on calc results
        setValues(
            Object.fromEntries(options.map((f) => [f?.id_name, parseFloat(placeholderData?.[category]?.[f?.id_name])]))
        )
    },[placeholderData])

    return (
        <>
        { groupedOptions?.length > 0 ?
        groupedOptions.map((group, gix) => (
            <StyledAccordion disableGutters elevation={0} key={gix} expanded={expanded === gix} onChange={handleExpand(gix)} >
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    id={gix+"header"}
                >
                    <Typography>{ group.label }</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    { group.options.map((opt, oix) => {
                        return <InputField 
                            key={oix}
                            opt={opt} 
                            values={values} 
                            handleChange={handleChange} 
                            setFocus={setFocus} 
                            isReadOnly={isReadOnly} 
                            units={units} 
                            error={(errorMsg !== '')}
                        />
                    }) }
                </AccordionDetails>
            </StyledAccordion>
        ))
        :
        options.map((opt, oix) => {
            return <InputField 
                key={oix}
                opt={opt} 
                values={values} 
                handleChange={handleChange} 
                setFocus={setFocus} 
                isReadOnly={isReadOnly} 
                units={units} 
                error={(errorMsg !== '')}
            />
        })}
        {errorMsg &&
        <FormHelperText sx={{ color: '#d32f2f' }}>
            { errorMsg }
        </FormHelperText>
        }
        </>
    );
}

const StyledAccordion = styled((props) => (
    <Accordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:first-of-type': {
        borderRadius: '12px 12px 0 0'
    },
    '&:last-of-type': {
        borderRadius: ' 0 0 12px 12px'
    },
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const InputField = ({ opt, values, handleChange, setFocus, isReadOnly, units, error }) => {
    let opt_id_name = opt?.id_name;
    return (
        <Grid key={opt_id_name} container spacing={1} mb={1}>
            <Grid 
                xs={12} 
                sm={3} 
                className='vertically-centered' 
                sx={{ cursor: 'pointer' }} title={opt.caption} 
            >
                <Typography variant="body2" color="text.secondary">{opt.label}</Typography>
            </Grid>
            <Grid xs={true}>
                <TextField
                    type="number"
                    size="small"
                    value={values[opt_id_name] || ''}
                    onChange={(e) => handleChange(opt_id_name, parseFloat(e.target.value) || 0)}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                    error={error}
                    fullWidth
                />
            </Grid>
            <Grid
                xs={units ? 'auto' : 0}
                className='vertically-centered' 
                sx={{overflow: 'clip'}}
            >
                <Typography color="text.secondary">{ units }</Typography>
            </Grid>
        </Grid>
    )
}

